import * as React from "react";
import { ThemeProvider } from "styled-components";
import GlobalThemeStyles from "theme/GlobalThemeStyles";
import useThemes from "theme/hooks/useThemes";
import { COLOR_SCHEME_LIGHT } from "theme/constants";
import ColorSchemeContext from "theme/ColorSchemeContext";
const PDFExportThemeProvider = ({ children = void 0, skipGlobalStyles = false }) => {
  const { scTheme } = useThemes(COLOR_SCHEME_LIGHT, true);
  return /* @__PURE__ */ React.createElement(ColorSchemeContext.Provider, { value: COLOR_SCHEME_LIGHT }, /* @__PURE__ */ React.createElement(ThemeProvider, { theme: scTheme }, skipGlobalStyles ? null : /* @__PURE__ */ React.createElement(GlobalThemeStyles, null), children));
};
export default PDFExportThemeProvider;
